<script setup>
import { ref, nextTick } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import KnowledgeBaseForm from './KnowledgeBaseForm.vue';

const props = defineProps({
  knowledgeBase: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['close', 'updated']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const knowledgeBaseForm = ref(null);

// 更新知识库
const updateKnowledgeBase = async knowledgeBaseDetails => {
  try {
    await store.dispatch('pilotKnowledgeBases/update', {
      id: props.knowledgeBase.id,
      data: knowledgeBaseDetails,
    });
    useAlert(t('PILOT.KNOWLEDGE_BASES.EDIT.SUCCESS_MESSAGE'));
    emit('updated');
    dialogRef.value.close();
  } catch (error) {
    const errorMessage =
      error?.message || t('PILOT.KNOWLEDGE_BASES.EDIT.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = async knowledgeBaseDetails => {
  await updateKnowledgeBase(knowledgeBaseDetails);
};

const handleClose = () => {
  emit('close');
};

const handleCancel = () => {
  dialogRef.value.close();
};

const open = () => {
  dialogRef.value?.open();
  // 等待 DOM 更新后设置表单数据
  nextTick(() => {
    if (knowledgeBaseForm.value && props.knowledgeBase) {
      knowledgeBaseForm.value.setFormData(props.knowledgeBase);
    }
  });
};

defineExpose({ dialogRef, open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('PILOT.KNOWLEDGE_BASES.EDIT.TITLE')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="handleClose"
  >
    <KnowledgeBaseForm
      ref="knowledgeBaseForm"
      :is-edit="true"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
